import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import LinkIcon from '@mui/icons-material/Link';
import { useAuth } from '../hooks/useAuth';
import { Fab } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

export default function BasicSpeedDialCadastro({
  onClickDelete,
  onClickEdit,
  onClickCancel,
  fornecedor,
}) {
  const { user, isUsuarioSebrae } = useAuth();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const itemsMenu = [
    function () {
      return (fornecedor && fornecedor.status == 'RASCUNHO') ||
        fornecedor.status == 'ERRO' ||
        fornecedor.status == 'PENDENCIA DO FORNECEDOR' ||
        fornecedor.status == 'VENCIDO' ||
        fornecedor.status == 'ATIVO' ? (
        <MenuItem onClick={() => onClickEdit(fornecedor.id, fornecedor.status)}>
          <Fab size="small" color="secondary" aria-label="Editar">
            <BorderColorIcon color="primary" />
          </Fab>
        </MenuItem>
      ) : null;
    },
    function () {
      return fornecedor &&
        fornecedor.status == 'RASCUNHO' &&
        isUsuarioSebrae ? (
        <MenuItem onClick={() => onClickDelete(fornecedor.id)}>
          <Fab
            style={{ marginTop: 5 }}
            size="small"
            color="secondary"
            aria-label="Deletar"
          >
            <DeleteOutlinedIcon color="error" />
          </Fab>
        </MenuItem>
      ) : null;
    },
    function () {
      return fornecedor &&
        !['ATIVO', 'RASCUNHO', 'CANCELADO', 'EM CANCELAMENTO'].includes(
          fornecedor.status,
        ) &&
        isUsuarioSebrae ? (
        <MenuItem onClick={() => onClickCancel(fornecedor.id)}>
          <Fab
            style={{ marginTop: 5 }}
            size="small"
            color="secondary"
            aria-label="Deletar"
          >
            <DoNotDisturbIcon color="error" />
          </Fab>
        </MenuItem>
      ) : null;
    },
  ];

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <MoreVertIcon />
      </Button>

      {itemsMenu.filter((item) => item() !== null).length === 0 ? (
        <div></div>
      ) : (
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          {itemsMenu.map((item) => item())}
        </Menu>
      )}
    </div>
  );
}
